import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80",
        outline: "text-foreground",
        executive:
          "border-transparent bg-[#6B46FF]/10 text-[#6B46FF] dark:bg-[#6B46FF]/20 dark:text-[#a78bfa]",
        operations:
          "border-transparent bg-teal-500/10 text-teal-700 dark:bg-teal-500/20 dark:text-teal-300",
        sales:
          "border-transparent bg-blue-500/10 text-blue-700 dark:bg-blue-500/20 dark:text-blue-300",
        support:
          "border-transparent bg-amber-500/10 text-amber-700 dark:bg-amber-500/20 dark:text-amber-300",
        individual:
          "border-transparent bg-purple-500/10 text-purple-700 dark:bg-purple-500/20 dark:text-purple-300",
        scheduled:
          "border-transparent bg-sky-500/10 text-sky-700 dark:bg-sky-500/20 dark:text-sky-300",
        management:
          "border-transparent bg-slate-500/10 text-slate-700 dark:bg-slate-500/20 dark:text-slate-300",
        marketing:
          "border-transparent bg-rose-500/10 text-rose-700 dark:bg-rose-500/20 dark:text-rose-300",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
